// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e5e78827","238":"22fbcae2","239":"e01f0c89","455":"e743a8af"}[chunkId] + ".chunk.js";
};